import React from "react";
import { FormattedMessage } from "react-intl";
import { ReactComponent as Logo } from "../../../../assets/mobile/logo.svg";
import "./download.scss";
import { ReactComponent as Apple } from "../../../../assets/Home/apple.svg";
import { ReactComponent as Google } from "../../../../assets/Home/google.svg";
const Download = () => {
  return (
    <div className="mobile-download">
      <div className="text">
        <Logo />
        <h1 className="mid-title">
          <FormattedMessage
            id="mobile-download-title"
            defaultMessage="Download app now"
          />
        </h1>
        <p className="def-text">
          <FormattedMessage
            id="mobile-download-text"
            defaultMessage="Our app is available for free on Apple Store and Google Play Store. Find all the unique features and monetization solutions you need as publisher and affiliate or explore our highly engaging ad units for advertisers."
          />
        </p>
        <div className="btns">
          <button>
            <Apple />
            <div className="text1">
              <small>
                <FormattedMessage
                  id="apple-small"
                  defaultMessage="Download on the"
                />
              </small>
              <h3>AppStore</h3>
            </div>
          </button>

          <button>
            <Google />
            <div className="text1">
              <small>
                <FormattedMessage
                  id="google-small"
                  defaultMessage="GET IT ON"
                />
              </small>
              <h3>PlayStore</h3>
            </div>
          </button>
        </div>{" "}
      </div>
    </div>
  );
};

export default Download;
